<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from '../components/modal/Modal.svelte';
    import Checkbox from "../components/controls/Checkbox.svelte";
    import {setFocusTo} from "../lib/lib";
    import Notifier from "../stores/notifier";

    export let userId = null;
    export let closeCallback;

    let userData = null;
    let changePassword = false;

    const initialize = () => {
        if (userId == 0) {
            userData = {
                id: 0,
                name: '',
                email: '',
                password: '',
            }
            setFocusTo('userName');
        } else {
            load();
        }
    }

    const load = () => {

        const onSuccess = result => {
            userData = result;
            setFocusTo('userName');
        };

        const onFailure = err => {
        };

        R.handle(R.user.details, userId, onSuccess, onFailure, LOADER.POPUP);
    };


    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Ο λογαριασμός του χρήστη ενημερώθηκε!");
            close(result);
        }

        const onFailure = err => {
            console.log(err);
            if (err.message) {
                Notifier.showError(err.message);
                if (err.code == 'user_account_exist') {
                    setFocusTo("userEmail");
                }
            }
        };


        userData.name = userData.name.trim();
        userData.email = userData.email.trim();
        if (!userData.name) {
            Notifier.showError("Πληκτρολογήστε το όνομα του χρήστη!");
            setFocusTo("userName");
            return;
        }
        if (!userData.email) {
            Notifier.showError("Πληκτρολογήστε το email του χρήστη!");
            setFocusTo("userEmail");
            return;
        }
        if (userData.id == 0 && !userData.password) {
            Notifier.showError("Πληκτρολογήστε τον κωδικό του λογαριασμού!");
            setFocusTo("password");
            return;
        }
        if (changePassword && !userData.password) {
            Notifier.showError("Πληκτρολογήστε τον νέο κωδικό του λογαριασμού!");
            setFocusTo("newPassword");
            return;
        }

        if (userData.id > 0 && !changePassword) {
            delete (userData.password);
        }

        let action = userId == 0 ? 'create' : 'edit';
        R.handle(R.user[action], userData, onSuccess, onFailure, LOADER.POPUP);
    }

    const close = (param) => {
        userData = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    const toggleChangePassword = () => {
        changePassword = !changePassword;
        if (changePassword) {
            setFocusTo("newPassword");
        } else {
            delete (userData.password);
        }
    }

    initialize();
</script>

{#if userData}
    <Modal title="Λογαριασμός Χρήστη" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <label>Όνομα</label>
                <input type="text" class="form-control" id="userName" bind:value="{ userData.name }">
            </div>
            <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control" id="userEmail" bind:value="{ userData.email }">
            </div>
            {#if userData.id == 0}
                <div class="form-group">
                    <label>Κωδικός</label>
                    <input type="text" class="form-control" id="password" bind:value="{ userData.password }">
                </div>
            {:else}
                {#if !changePassword}
                    <div class="form-group">
                        <button class="btn btn-link ps-0" on:click="{ toggleChangePassword }">
                            Αλλαγή κωδικού
                        </button>
                    </div>
                {:else}
                    <div class="form-group">
                        <label>Νέος κωδικός</label>
                        <input type="text" class="form-control" id="newPassword" bind:value="{ userData.password }">
                        <button class="btn btn-link ps-0" on:click="{ toggleChangePassword }">
                            Να μην αλλάξει ο κωδικός
                        </button>
                    </div>
                {/if}
            {/if}
            <hr>
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Ενημέρωση</button>
            </div>
        </div>
    </Modal>
{/if}